<template>
  <b-form @submit.prevent="submit" class="flex-center">
    <AuthWrapper
      :label="label"
      rightIcon="arrow-right"
      @handleRightIcon="goToActiveRegistrations"
    >
      <template #main>
        <b-row>
          <b-col v-if="hasNationalCode" cols="12" md="12">
            <Input
              :title="dynamicLabel"
              :label="$lang.national_code"
              :placeholder="$lang.national_code"
              :value="form.nationalCode"
              name="nationalCode"
              id="nationalCode"
              type="text"
              :minLength="lengthNumber10"
              :maxLength="lengthNumber10"
              :vuelidateObj="$v.form.nationalCode"
              :hasLeftIcon="true"
              @input="input"
              @focus="resetValidation"
              @blur="checkValidation"
            />
          </b-col>
          <b-col cols="12" md="12">
            <Input
              :title="!hasNationalCode ? dynamicLabel : ''"
              :label="dynamicFieldCaption"
              :placeholder="dynamicFieldCaption"
              :value="form.dynamicField"
              name="dynamicField"
              id="dynamicField"
              type="text"
              :vuelidateObj="$v.form.dynamicField"
              :hasLeftIcon="true"
              @input="input"
              @focus="resetValidation"
              @blur="checkValidation"
            />
          </b-col>
          <b-col cols="12" md="12">
            <Captcha
              :value="form.captcha"
              id="captcha"
              name="captcha"
              :minLength="captchaLength"
              :maxLength="captchaLength"
              :vuelidateObj="$v.form.captcha"
              @input="input"
              @getKey="updateCaptchaKey"
              @setShowCaptcha="setShowCaptcha"
              @focus="resetValidation"
              @blur="checkValidation"
            />
          </b-col>
        </b-row>
      </template>
      <template #button>
        <b-row>
          <b-col cols="12" md="12">
            <Button
              class="w-100"
              contentClass="justify-content-center"
              variant="primary"
              :text="$lang.continue"
              :loading="loading"
              type="submit"
              @click="submit"
            />
          </b-col>
        </b-row>
      </template>
    </AuthWrapper>
  </b-form>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { AuthWrapper } from "@/components/re-design";
import { Input, Captcha, Button } from "@/components/re-design/forms";
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { pathOr, includes } from "ramda";
import { goToRoute, storeDispatcher } from "@/shared/utils";
import { confirmRegistrationCode } from "@/modules/auth/services";

export default {
  inject: ["goToActiveRegistrations"],
  mixins: [inputMixin],
  components: {
    AuthWrapper,
    Input,
    Captcha,
    Button,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    dynamicFieldCaption: {
      type: String,
      default: "",
    },
    hasNationalCode: {
      type: Boolean,
      default: false,
    },
  },
  validations() {
    return {
      form: {
        nationalCode: {
          required: requiredIf(() => this.hasNationalCode),
          numeric,
          minLength: minLength(this.lengthNumber10),
          maxLength: maxLength(this.lengthNumber10),
        },
        dynamicField: { required },
        captcha: {
          required: requiredIf(() => this.showCaptcha),
          minLength: minLength(this.captchaLength),
          maxLength: maxLength(this.captchaLength),
        },
      },
    };
  },
  data() {
    return {
      form: {
        nationalCode: null,
        dynamicField: null,
        captcha: null,
        captchaKey: null,
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["preRegisterCode"]),
    dynamicLabel() {
      const label = this.hasNationalCode
        ? this.$lang.dynamicFieldCaptionWithNationalCode
        : this.$lang.dynamicFieldCaption;
      return label.replace("{0}", this.dynamicFieldCaption || "");
    },
  },
  methods: {
    pathOr,
    includes,
    goToRoute,
    goToAuthMobile() {
      goToRoute("auth-mobile", {}, {}, false);
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const nationalCode = this.form.nationalCode;
        const dynamicField = this.form.dynamicField;
        const captcha = this.form.captcha;
        const key = this.form.captchaKey;

        const response = await confirmRegistrationCode(
          nationalCode,
          dynamicField,
          captcha,
          key
        );
        const { registerStatus, message } = response;
        this.$notify.success(message);

        /*
         * register_code_confirmed => redirect to identity form for insert information
         * register_done => successfully and completed register and redirect to register result page
         */
        if (registerStatus === "register_code_confirmed") {
          goToRoute("personal-information", {}, {}, false);
        }
        if (registerStatus === "register_done") {
          goToRoute("result-registrations", {}, {}, false);
        }
      } catch (error) {
        this.$generateError(error);
        storeDispatcher("shouldRefreshCaptcha", true);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
